import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DeepPartial, ICustomerSearchRequest, IFormGroupSchema, Optional } from '@lib/interfaces';
import { ValueFieldModule } from '@lib/modules';
import { AngularMaterialModule } from 'src/app/material.module';

export type IMutateNotificationForm = IFormGroupSchema<DeepPartial<ICustomerSearchRequest>>;

@Component({
    selector: 'app-advanced-search-modal',
    standalone: true,
    imports: [AngularMaterialModule, ReactiveFormsModule, ValueFieldModule],
    templateUrl: './advanced-search-modal.component.html',
    styleUrls: ['./advanced-search-modal.component.scss'],
})
export class AdvancedSearchModalComponent implements OnInit {
    public advancedSearchForm: FormGroup<IMutateNotificationForm>;
    constructor(public dialogRef: MatDialogRef<AdvancedSearchModalComponent>, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: { filterResult: ICustomerSearchRequest, title: string }) {}

    ngOnInit(): void {
        this.advancedSearchForm = this.createForm();
    }

    protected createForm(): FormGroup<IMutateNotificationForm> {
        const { mobile, email } = this.data.filterResult;
        return this.formBuilder.group<IMutateNotificationForm>({
            mobile: this.formBuilder.nonNullable.control(mobile ?? ''),
            email: this.formBuilder.nonNullable.control(email ?? ''),
        });
    }

    protected clearControl(control: FormControl<Optional<string>> | undefined): void {
        control?.setValue('');
    }

    protected onClose(): void {
        const { mobile, email } = this.data.filterResult;
        this.advancedSearchForm.patchValue({
            mobile,
            email,
        });
        this.dialogRef.close(null);
    }
}
